import z from 'zod';

/**
 * How far through a part of the event hierarchy is. Every level uses the same three values, because
 * they mean the same thing at every level.
 */
export const ProgressStatus = {
    Waiting: 'Waiting',
    Active: 'Active',
    Finished: 'Finished',
} as const;
export type ProgressStatus = (typeof ProgressStatus)[keyof typeof ProgressStatus];
export const ProgressStatusEnum = z.enum(ProgressStatus);
